import * as XLSX from "xlsx";
import moment from "moment";
import { extractExamFromMetadata } from "../../utils/metadata";

const findConclusion = (exam: Exam): string => {
    // if (!exam) return "Invalido";

    const conclusion =
        exam?.form.find((field) => field.type === "conclusiones")?.response
            ?.input_value || "otro";

    return conclusion.replaceAll("_", " ").toUpperCase();
};

const findExam = (appointment: any) => {
    return extractExamFromMetadata(appointment.metadata);
};

const findConclusionComents = (exam: Exam): string => {
    const conclusionComments = exam?.form.find((field) => field.type === "textarea")?.response
        ?.input_value || null;

    return conclusionComments
}


const returnDateTime = (rowData: any) => {
    if (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada') return "---";
    if (rowData?.startTime) return `${rowData.date} - ${rowData?.startTime}`;
    return "---";
}

const returnAppType = (rowData: any) => {
    if (rowData.type === 'Videollamada') return 'Telecontrol'
    if (rowData.type === 'Visita a Domicilio') return 'Control en Domicilio'
    if (rowData.type === 'Consulta en Lavoris') return 'Control en Consultorio Lavoris'
    if (rowData.type === 'Define Lavoris') return 'AI - Ausentismo Inteligente'
    if (rowData?.isPrestador) return 'Turno Externo'
    return 'Control en Consultorio Lavoris';
}


const returnAdmissionDate = (rowData: any) => {
    if (rowData?.admissionTime) return rowData?.admissionTime;
    if (rowData?.report?.visitManualTime) return rowData?.report?.visitManualTime;
    return "---";
}


const candidatesDiagnostics = (item: any) => {
    const conclusion = findConclusion(findExam(item) as Exam)
        .split("_")
        .join(" ")
        .toLocaleLowerCase();
    const conclusionComments = findConclusionComents(findExam(item) as Exam)
    let a = (item.status !== 'Aptitud parcialmente completada' && conclusion.length > 0 && conclusionComments) && `${conclusion}: ${conclusionComments}`;
    let b = (item.status !== 'Aptitud parcialmente completada' && conclusion.length === 0 && conclusionComments) && `${conclusionComments}`;
    let c = (item.status === 'Aptitud parcialmente completada' && conclusion.length > 0) ? conclusion : "";
    let d = (item.status !== 'Aptitud parcialmente completada' && conclusion.length === 0 && !conclusionComments) && "";
    let e = (item.status !== 'Aptitud parcialmente completada' && conclusion.length > 0 && !conclusionComments) && `${conclusion}`
    return a || b || c || d || e
}



const employeeResult = (item: any) => {
    const simplified = item?.metadata?.simplified
    const form = simplified
        ?.map((s: any) => s.form)
        ?.filter((f: any) => f !== undefined);
    //console.log(form)

    const findControlEnConsultorio = (formArray: any) => {
        return formArray?.find((element: any) => element?.label === 'Control en Consultorio');
    };

    const diagnostico = form?.map((a: any) => {
        //console.log(a)
        const controlEnConsultorio = findControlEnConsultorio(a);
        // console.log(controlEnConsultorio)
        if (controlEnConsultorio) {
            const diagnostico = a?.find((element: any) => element?.label === 'Diagnosticos' || element?.label === 'Diagnósticos');
            if (diagnostico) {
                const diag = diagnostico?.response?.input_value?.label?.trim();
                return diag?.replace(/,/g, '') || "---"
            }
        }

        const isICTraumatologica = a?.find((element: any) => element?.label === 'Interconsulta Traumatológica');
        if (isICTraumatologica) {
            const result = a?.find((element: any) => element?.label === 'Informe');
            return result?.response?.input_value
        }

        const isICNeurologica = a?.find((element: any) => element?.label === "Interconsulta Neurologica");
        if (isICNeurologica) {
            const result = a?.find((element: any) => element?.label === 'Informe');
            return result?.response?.input_value
        }
    })

    return diagnostico
}

const absenteeResult = (item: any) => {
    if (!item) return;
    const report = item?.report;
    const diagnostico = report?.diagnostic;
    return diagnostico
}

const returnDiagnostics = (rowData: any) => {
    if (rowData?.patient && rowData?.patient.type === 'CANDIDATE') {
        return candidatesDiagnostics(rowData)
    };

    if ((rowData?.patient && rowData?.patient?.type === 'EMPLOYEE') || (rowData?.patient && rowData?.patient.employee)) {
        return employeeResult(rowData)
    };

    if (rowData?.type && (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada')) {
        return absenteeResult(rowData)
    };

    return "---"
}

const controlConsultorio = (item: any) => {
    if ((item?.patient?.type === 'EMPLOYEE') || (item?.patient && item?.patient?.employee)) {
        const simplified = item?.metadata?.simplified
        const form = simplified
            ?.map((s: any) => s.form)
            ?.filter((f: any) => f !== undefined);


        const findControlEnConsultorio = (formArray: any) => {
            return formArray?.find((element: any) => element?.label === 'Control en Consultorio')
        };


        const estadoAtencion = form?.map((a: any) => {
            const controlEnConsultorio = findControlEnConsultorio(a);
            if (controlEnConsultorio && controlEnConsultorio !== undefined) {
                const estadoAtencion = a?.find((element: any) => element?.label === "Estado de la atención");
                if (estadoAtencion) {
                    return estadoAtencion?.response?.input_value;
                }
                return
            }
        })

        const fechaAlta = form?.map((a: any) => {
            const controlEnConsultorio = findControlEnConsultorio(a);
            if (controlEnConsultorio && controlEnConsultorio !== undefined) {
                const fechaAlta = a?.find((element: any) => element?.label === "Fecha" || element?.label === "Fecha de alta");
                if (fechaAlta) {
                    return moment(fechaAlta?.response?.input_value).format('DD/MM/YYYY');
                }
                return
            }
        })

        const inasistenciaJust = form?.map((a: any) => {
            const controlEnConsultorio = findControlEnConsultorio(a);
            if (controlEnConsultorio && controlEnConsultorio !== undefined) {
                const inasistenciaJust = a?.find((element: any) => element?.label === "¿Inasistencia Justificada?");
                if (inasistenciaJust) {
                    return inasistenciaJust?.response?.input_value
                }
                return
            }
        })

        const diasJust = form?.map((a: any) => {
            const controlEnConsultorio = findControlEnConsultorio(a);
            if (controlEnConsultorio && controlEnConsultorio !== undefined) {
                const inasistenciaJust = a?.find((element: any) => element?.label === "Días justificados");
                if (inasistenciaJust) {
                    return inasistenciaJust?.response?.input_value
                }
                return
            }
        })
        return { estadoAtencion, fechaAlta, inasistenciaJust, diasJust }
    }
    if (item?.type && (item?.type === 'Visita a Domicilio' || item?.type === 'Videollamada')) {

        const report = item?.report;
        const estadoAtencion = item?.status;
        const inasistenciaJust = report?.isAbsenceJustified || '---';
        const fechaAlta = report?.isAbsenceJustified ? report?.releaseDate : '---'
        const diasJust = report?.isAbsenceJustified ? report?.absenceDaysJustifiedByLavoris : '---';
        return { estadoAtencion, fechaAlta, inasistenciaJust, diasJust }
    }
    return '---'
}

const returnPracticeName = (rowData: any) => {
    const molde = rowData?.metadata?.molde || [];
    const exam = rowData?.metadata?.exam || [];
    const practices = rowData?.metadata?.practices || [];
    const practiceInMolde = rowData?.metadata?.molde?.practices || [];
    const allPractices = [];
    if (exam.practices) {
        allPractices.push(...exam.practices);
    }
    if (molde.exams && molde.exams[0] && molde.exams[0].practices) {
        allPractices.push(...molde.exams[0].practices);
    }
    if (practices) {
        allPractices.push(...practices);
    }
    if (practiceInMolde) {
        allPractices.push(...practiceInMolde);
    }
    const practiceNames =
        allPractices.length > 0
            ? allPractices.map((practice: any) => practice.name).join(", ")
            : molde.practices && molde.practices.length > 0
                ? molde.practices.map((practice: any) => practice.name).join(", ")
                : practices && practices.length > 0
                    ? practices.map((practice: any) => practice.name).join(", ")
                    : practiceInMolde && practiceInMolde.length > 0
                        ? practiceInMolde.map((practice: any) => practice.name).join(", ")
                        : "---";

    if (rowData?.metadata) return practiceNames
    if (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada') return rowData?.practiceName
    return '---'

}

const returnRetiro = (rowData: any) => {
    if (!rowData?.actions || rowData?.actions?.length === 0) return '---';

    const retirado = rowData?.actions.filter((action: any) => action.action === 'RETIRADO');
    if (retirado.length === 0) return '---';
    return moment(retirado[0].date).format('DD/MM/YYYY HH:mm');
};


const professional = (item: any) => {
    const metadata = item?.metadata
    const molde = metadata?.molde || [];
    const exam = metadata?.exam || [];
    const practices = metadata?.practices || [];
    const simplified = metadata?.simplified || [];
    const isAbsentee = item.type === 'Visita a Domicilio' || item.type === 'Videollamada'
    let professional = null;
    let allowExam: string[] = [];

    if ((molde?.name?.includes('Medico en planta')) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
        allowExam = ['PRACTICE_IN_MOLDE']
        professional = simplified?.filter((p: any) => allowExam.includes(p.type))[0]?.professional
        if (professional) {
            return `${professional?.title} ${professional?.name}`
        }
    }

    if ((metadata && practices.length === 1) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
        professional = simplified?.filter((p: any) => p.type === 'PRACTICE')[0]?.professional
        if (professional) {
            return `${professional?.title} ${professional?.name}`
        }
    }

    if ((metadata && practices.length > 1) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
        professional = simplified?.map((p: any) => p).map((prof: any) => prof.professional);

        if (professional.length > 1) {
            // Mapear para obtener la propiedad que necesitas de cada objeto y separarlos con un guion
            professional = professional.map((p: any) => `${p?.title} ${p?.name}`).join(' - ');
            return professional;
        }
    }



    if ((molde || exam) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
        allowExam = ['EXAM', 'EXAM_IN_MOLDE']
        professional = simplified?.filter((p: any) => allowExam.includes(p.type))[0]?.professional
        if (professional) {
            return `${professional?.title} ${professional?.name}`
        }
    }

    if (isAbsentee && item.status === 'Completada') {
        professional = item.specialist
        return `${professional?.abbreviation}  ${professional?.name}`
    }

    return '---'
}




const exelReports = async (rowData: any, isIndividual: boolean) => {

    if (rowData.length === 0 || !rowData) return

    const headers = [
        "Nombre",
        "DNI",
        "Empleado o Postulante",
        "Puesto",
        "AI",
        "Tipo de atención",
        "Fecha de solicitud del servicio o atención médica",
        "Fecha del turno del servicio o atención médica",
        "Fecha y hora de admisión / visita / videollamada",
        "Fecha y hora de retiro (si aplica)",
        "Llegada tarde",
        "Tiempo de tardanza",
        "Examen",
        "Practicas",
        "Profesional CM",
        "Matricula CM",
        "Fecha CM",
        "Días otorgados CM",
        "Profesional - Profesionales Lavoris",
        "Resultado - Diagnostico",
        "Estado de la atención",
        "Inasistencia justificada",
        "Días justificados",
        "Fecha de alta",
        "Estado del servicio-prestación",

    ];

    const excelDataPromises = rowData?.map(async (item: any) => {
        const fullname = item?.metadata?.patient?.name?.toUpperCase() || item?.patient?.name?.toUpperCase() || item?.patient?.employee?.user?.name?.toUpperCase() || item?.employee.name.toUpperCase() || "---";
        const dni = item?.metadata?.patient?.DNI || item?.patient?.DNI || item?.patient?.employee?.user?.DNI || item?.employee?.DNI || "---";
        const positionName = item?.metadata?.patient?.positionName || item?.patient?.positionName || item?.patient?.employee?.user?.positionName || item?.employee?.positionName || "---";
        const employeeType = item?.metadata?.patient?.type || item?.patient?.type || item?.patient?.employee?.user?.type || item?.employee?.type || "---";
        const appType = returnAppType(item);
        const appStatus = item?.status;
        const requestedDate = moment(item.createdDate).format('DD/MM/YYYY HH:mm') || "---";
        const appDateTime = returnDateTime(item);
        const addmissionDateTIme = returnAdmissionDate(item)
        const gia = item?.gia ? 'Si' : 'No';

        const molde = item?.metadata?.molde || [];
        const exam = item?.metadata?.exam || [];
        const examName = exam.name || (molde.exams && molde.exams[0] && molde.exams[0].name) || "---";
        const diagnostics = returnDiagnostics(item) || "---";
        const controlConsultorioResult = controlConsultorio(item);

        const isLate = rowData?.status === 'Ausente' || rowData?.status === 'Eliminado' || rowData?.status === 'Cancelado' ? 'Si' : item?.is_late ? 'Si' : 'No';
        const tardiness = rowData?.status === 'Ausente' || rowData?.status === 'Eliminado' || rowData?.status === 'Cancelado' ? 'No se presentó - Cancelado' : item?.tardiness ? item?.tardiness : '---';
        const certificate_professional_name = item?.report?.certificateProfessionalName || "---";
        const certificate_professional_license = item?.report?.certificateProfessionalLicense || "---";
        const certificate_professional_date = item?.report?.certificateDate || "---";
        const certificate_professional_days = item?.report?.certificateJustifiedDays || "---";

        return [
            fullname,
            dni,
            employeeType === 'CANDIDATE' ? 'Postulante' : 'Empleado',
            positionName,
            gia,
            appType,
            requestedDate,
            appDateTime,
            addmissionDateTIme,
            returnRetiro(item),
            isLate,
            tardiness,
            examName,
            returnPracticeName(item),
            certificate_professional_name,
            certificate_professional_license,
            certificate_professional_date,
            certificate_professional_days,
            professional(item),
            diagnostics,
            ...(typeof controlConsultorioResult === 'object' ? [
                controlConsultorioResult.estadoAtencion,
                controlConsultorioResult.inasistenciaJust,
                controlConsultorioResult.diasJust,
                controlConsultorioResult.fechaAlta
            ] : ['---', '---', '---', '---']),
            appStatus,

        ]
    })
    const excelData = await Promise.all(excelDataPromises);

    // Asegurarse de que todo sea texto
    const formattedExcelData = excelData.map(row => row.map((cell: any) => ({ v: cell, z: '@' })));

    const ws = XLSX.utils.aoa_to_sheet([headers.map(header => ({ v: header, z: '@' })), ...formattedExcelData]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    let fullname: string = "";
    const date = moment().format('DD/MM/YYYY');
    let filename = isIndividual ? `Reportes-Servicios-Prestaciones-de-${fullname}-${date}.xlsx` : `Reportes-Servicios-Prestaciones-todos-${date}.xlsx`;

    if (isIndividual) {
        fullname = (
            rowData[0]?.metadata?.patient?.name?.toUpperCase()
            || rowData[0]?.patient?.name?.toUpperCase()
            || rowData[0]?.patient?.employee?.user?.name?.toUpperCase()
            || rowData[0]?.employee?.name.toUpperCase()
            || "---"
        ).replace(/[^\w\s]/gi, '');
    }

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    return excelDataPromises;

}

export default exelReports